// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Dv-z","tooltipWrapper":"Ev-z","icon":"Fv-z","tooltip":"Gv-z","content":"Hv-z"};